<!--
 Copyright 2024 Tobias Olenyi.
 SPDX-License-Identifier: Apache-2.0
-->
<script lang="ts">
  import { afterUpdate } from "svelte";

  let className = "";
  export { className as class };
</script>

<svg
  xmlns="http://www.w3.org/2000/svg"
  viewBox="0 0 139.84 146.35"
  class={className}
>
  <path
    id="DB-back"
    class="database"
    d="M.09,32.89C.09,25.63,6.91,19.45,20.53,14.34c13.63-5.11,30.1-7.66,49.44-7.66s35.81,2.55,49.44,7.66c13.63,5.11,20.44,11.29,20.44,18.54l-9.24-.12c-2.39-4.33-9.87-8.31-22.45-11.92-12.58-3.62-25.31-5.42-38.19-5.42s-25.4,1.74-38.13,5.23c-12.73,3.49-20.35,7.3-22.84,11.44L.09,32.89Z"
  />
  <g id="Protein">
    <path
      id="Loop-3"
      class="loop"
      d="M17.44,92.33c-1.99,3.32-2.89,5.43-3.86,7.42-.46.96-.17,2.11.69,2.74.1.08.22.14.33.2,1.09.53,2.39.07,2.92-1.01.76-1.57,1.66-3.28,3.55-6.44"
    />
    <path
      id="Loop-2"
      class="loop"
      d="M75.5,9.4c2.75-3.01,5.1-5.21,7.72-6.74,7.15-4.15,14.27-3.43,20.64,2.04,6.64,5.73,5.06,16.86,4.99,17.32-.28,1.38-1.63,2.28-3.01,2-1.28-.26-2.16-1.44-2.04-2.74.02-.12,1.22-8.82-3.28-12.69-4.65-4.03-9.49-4.52-14.73-1.48-2.01,1.16-3.97,2.84-6.22,5.23"
    />
    <path
      id="Helix"
      class="helix"
      d="M77.72,13.75l8.16,5.85-45.69,63.73,9.64,6.91-28.76,4.98-3.66-2.89-4.85-28.81,9.41,6.75L67.66,6.53l5.86,4.2"
    />
    <g id="Strand" class="strand">
      <path
        id="Strand-4"
        d="M103.97,34.24c1.19,3.34,1.97,4.89,2.27,5.44.29.56,3.78,6.54,4.49,7.52.7.97,2.61,4.79,3.24,5.69.49.73.93,1.69,1.19,2.26,0,.63-.04,1.21-.2,1.37-.35.45-.87.74-1.43.81-.85.08-3.98-.68-5.04-.98-.98-.25-5.87-1.4-7.14-1.74-.45-.12-2.2-.43-4.39-.81-.78-1.13-1.73-2.5-2.04-3.05-.57-1-2.56-4.87-2.97-6.55-.42-1.7-.71-3.59-.68-4.56.04-1.46,2-5.12,3.02-6.32.6-.72,8.12-10.9,8.12-10.9,0,0-.24,6.78,1.56,11.82Z"
      />
      <path
        id="Strand-3"
        d="M85.94,102.17c-.88,1.23-2.97,3.93-3.84,4.7-.87.78-2.04,1.56-2.83,1.73-1.1.24-4.23.08-5.87-.39-.88-.26-2.81-.67-4.57-1.07-1.31-.3-2.61-.61-3.91-.94-5.86-1.42-11.76-2.84-12.54-3-1.68-.27-4.67-.64-6.07-.17-.59.22-1.22.44-1.84.86.65-1.43,1.37-2.83,2.17-4.19.87-1.38,3.63-4.85,4.96-6.05,1.13-1.03,3.09-2.59,5.04-2.91.8-.12,2.49-.16,4.44-.1,3.96.65,12.61,2.08,13.5,2.32,1.29.34,6.2,1.5,7.13,1.73,1.16.3,4.09,1.1,5.54,1.03.8-.09,1.55-.44,2.14-.98-.03.64-.11,1.39-.24,1.95-.45,1.79-2.29,4.26-3.16,5.48Z"
      />
      <path
        id="Strand-2"
        d="M67.32,74.16c.04-.06.23-.24.65-.74.68-.78,1.13-.88,2.15-1.27.51-.26,3.84-.05,5.25.25.43.09,2.78.64,5.85,1.38.12.18.21.34.26.42.29.56,3.78,6.55,4.49,7.52.7.97,2.61,4.79,3.24,5.7.5.72.94,1.7,1.2,2.26.01.63-.02,1.22-.2,1.36-.35.45-.87.74-1.43.81-.85.08-3.98-.68-5.05-.98-.96-.25-5.88-1.4-7.13-1.74-.45-.11-2.21-.42-4.41-.8-.78-1.14-1.72-2.5-2.02-3.05-.57-.99-2.57-4.86-2.98-6.55-.16-.63-.3-1.27-.42-1.91.03-.71.08-1.57.23-1.94.09-.25.19-.49.32-.72Z"
      />
      <path
        id="Strand-1"
        d="M110.73,67.6c-.88,1.23-2.97,3.92-3.84,4.69-.87.77-2.04,1.56-2.83,1.73-.74.16-2.41.14-3.92-.04-5.69-1.38-21.56-5.24-22.88-5.49-1.68-.28-4.65-.65-6.07-.18-.61.23-1.26.45-1.9.91.64-1.39,1.34-2.75,2.12-4.07.88-1.39,3.63-4.84,4.96-6.06,1.11-1.01,3.09-2.58,5.02-2.9,1.07-.12,2.15-.16,3.23-.12,2.7.43,13.87,2.27,14.89,2.55,1.29.33,6.2,1.5,7.13,1.73,1.15.29,4.09,1.09,5.52,1.03.71-.07,1.38-.34,1.94-.78-.05.54-.11,1.09-.21,1.53-.44,1.78-2.29,4.26-3.16,5.49Z"
      />
    </g>
    <path
      id="Loop-1"
      class="loop"
      d="M59.96,134.94c-1.63-.65-3.28-1.39-4.87-2.53-2.45-1.76-4.75-4.44-6.58-9.13-3.19-8.17,3.39-17.26,3.68-17.65.78-1.13,2.33-1.41,3.46-.63.04.03.07.05.11.08,1.14.84,1.38,2.44.55,3.58-.05.07-5.2,7.22-3.04,12.75,2.29,5.87,5.13,7.4,8.59,8.79,1.33.47,2.03,1.93,1.56,3.26-.47,1.33-1.93,2.03-3.26,1.56-.07-.02-.13-.05-.2-.08Z"
    />
  </g>
  <path
    id="DB-front"
    class="database"
    d="M69.87,146.35c-20.42,0-37.16-2.6-50.25-7.8C6.54,133.35,0,126.66,0,118.46V32.81l8.9-.79c2.38,4.37,9.88,8.34,22.5,11.93,12.62,3.59,25.45,5.38,38.47,5.38M69.87,49.31c12.51,0,25.11-1.74,37.82-5.23,12.72-3.49,20.32-7.29,22.81-11.4l9.24.12v85.67c0,8.18-6.54,14.87-19.63,20.08-13.08,5.21-29.83,7.81-50.25,7.8M69.87,137.62c7.48,0,14.6-.43,21.34-1.28,6.74-.85,12.8-2.06,18.18-3.62,5.38-1.56,9.95-3.43,13.71-5.6,3.76-2.17,6.4-4.52,7.9-7.03V43.94c-3.56,2.15-7.6,4.09-12.14,5.8-4.52,1.71-9.43,3.14-14.71,4.28-5.28,1.15-10.82,2.02-16.6,2.6-5.79.58-11.68.87-17.69.87s-12.28-.32-18.16-.96c-5.88-.64-11.42-1.53-16.65-2.67s-10.06-2.54-14.53-4.21c-4.46-1.67-8.4-3.57-11.81-5.71v44.51s0,31.7,0,31.7c1.51,2.63,4.14,5,7.89,7.09,3.74,2.1,8.3,3.92,13.68,5.48,5.37,1.55,11.44,2.76,18.21,3.62s13.89,1.29,21.36,1.28"
  />
</svg>

<style>
  :global(html:not(.dark) .database) {
    fill: rgba(var(--color-surface-300));
  }
  :global(html.dark .database) {
    fill: rgba(var(--color-surface-600));
  }

  .helix {
    fill: rgba(var(--color-primary-500));
  }

  .strand {
    fill: rgba(var(--color-secondary-500));
  }

  .loop {
    fill: rgba(var(--color-surface-500));
  }
</style>
